<template>
  <!-- 修改字典对话框 -->
  <el-dialog
      title="修改字典"
      append-to-body
      :visible.sync="editDialogVisible"
      width="40%"
  >
    <el-form ref="editFormRef" :rules="rules" :model="editForm" label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="名称" prop="name">
            <el-input v-model="editForm.name" placeholder="请输入名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="图标" prop="icon">
            <picture-icon v-model="editForm.icon"></picture-icon>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button @click="modifyLabel">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {updateLabel} from "@/api/label/label";
import {getPostOrDeleteData} from "@/utils/code";
import PictureIcon from '@/components/common/picture/pictureIcon'
import { labelRules } from '@/js/rules'

export default {
  name: "editLabel",
  components: { PictureIcon },
  data() {
    return {
      editForm: {},
      editDialogVisible: false,
      rules: labelRules,
    }
  },
  methods: {
    cancel() {
      this.editDialogVisible = false
      this.editForm = {}
    },

    editDialog(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
    },

    modifyLabel() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        updateLabel(this.editForm.id, this.editForm).then((response) => {
          let data = getPostOrDeleteData(response);
          if (data !== null) {
            this.$emit('refresh-list')
            this.editDialogVisible = false;
          }
        })
      });
    },
  }
}
</script>

<style scoped lang="less">
/deep/.el-input {
  width: 90%;
}
</style>
